import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  EVENT_ADD_ACTION_TYPE,
  EVENT_DELETE_ACTION_TYPE,
  EVENT_DETAIL_ACTION_TYPE,
  EVENT_LIST_ACTION_TYPE,
  eventsAddUrl,
  eventsDeleteUrl,
  eventsDetailUrl,
  eventsListUrl,
  headers,
} from "../../utils/constants";
import moment from "moment";

export const event_list_action = (Name, Status) => async (dispatch) => {
  try {
    const mapdata = {
      userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      Name: Name.toString().trim(),
      Status: Status==1?1:Status==0?0:null,
    };
    const params = {
      userId:mapdata.userId==""?null:mapdata.userId,
      Name: mapdata.Name == "" ? null : mapdata.Name,
      Status: mapdata.Status,
    };
    console.log("Events mapdata...", mapdata);
    const res = await axiosGet(eventsListUrl, params,headers);
    console.log("Events", res);
    dispatch({
      type: EVENT_LIST_ACTION_TYPE,
      payload: res,
    });
    return res; // No need to wrap in Promise.resolve()
  } catch (err) {
    return Promise.reject(err);
  }
};

  export const event_detail_action = (TypeOfEventID) => async (dispatch) => {
    try {
      const params = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        TypeOfEventID: TypeOfEventID,
      };
      console.log("Events detail mapdata...", params);
      const res = await axiosGet(eventsDetailUrl, params,headers);
      console.log("detailsEvents", res);
      dispatch({
        type: EVENT_DETAIL_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const event_add_action = (
  
  TypeOfEventID,
  Name,
  Code,
  StatusID
) => async (dispatch) => {
  try {
    const mapdata = {
      userId: sessionStorage.getItem("userId") == "" ||
      sessionStorage.getItem("userId") == null
        ? ""
        : sessionStorage.getItem("userId"),
      TypeOfEventID: TypeOfEventID ? TypeOfEventID.toString().trim() : null,
      Name: Name.toString().trim(),
      Code: Code.toString().trim(),
      StatusID: StatusID?StatusID:0,
    };
    console.log("Events add mapdata...", mapdata);

    const res = await axiosPost(eventsAddUrl, mapdata, headers);
    dispatch({
      type: EVENT_ADD_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};


export const event_delete_action =( TypeOfEventID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        TypeOfEventID: TypeOfEventID ? TypeOfEventID.toString().trim() : "",
      };

      const res = await axiosGet(eventsDeleteUrl, mapdata,headers);
      dispatch({
        type: EVENT_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
